import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import customO from '../components/rounded_beanbonus_icon_512.png';
import './HeaderBlock.css';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig'; // Website's functions instance

function HeaderBlock() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);
  const [firstName, setFirstName] = useState('');

  // Functions instance
  const signInUser = httpsCallable(functions, 'signInUser');

  // Toggle dropdown and close on link click
  const toggleMenu = (e, close = false) => {
    if (close && isMenuOpen) {
      setIsMenuOpen(false);
    } else {
      setIsMenuOpen(!isMenuOpen);
    }
  };

  // Toggle modal
  const toggleModal = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsModalOpen(!isModalOpen);
    setError(null);
    setEmail('');
    setPassword('');
  };

  // Handle sign-in
  const handleSignIn = async (e) => {
    e.preventDefault();
    try {
      const result = await signInUser({ email, password });
      const { uid, firstName } = result.data;
      console.log('Received UID and firstName:', uid, firstName);

      // Update UI with returned data
      setUser({ uid });
      setFirstName(firstName);
      setError(null);
      toggleModal();
    } catch (err) {
      console.error('Sign-in error:', err.message);
      setError(err.message || 'Failed to sign in. Please try again.');
    }
  };

  // Handle sign-out
  const handleSignOut = async () => {
    setUser(null);
    setFirstName('');
    setError(null);
    setIsMenuOpen(false);
  };

  return (
    <div className="header-block" style={{ marginTop: 0, paddingTop: 0 }}>
      <div className="header-left">
        <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
          <div className="header-logo">
            <img src={customO} alt="BeanBonus Logo" />
          </div>
          <div style={{ flexDirection: 'row', marginLeft: '8px' }}>
            <div className="header-title">BeanBonus</div>
            <div className="header-subtitle">The Coffee App</div>
          </div>
        </Link>
      </div>
      <div className="header-right">
        <button
          className={`header-menu-button ${isMenuOpen ? 'open' : ''}`}
          aria-label="Menu"
          onClick={toggleMenu}
        >
          <span className="hamburger-icon"></span>
          <span className="hamburger-icon"></span>
          <span className="hamburger-icon"></span>
        </button>
        {isMenuOpen && (
          <div className="dropdown-menu">
            {/* {user ? ( */}
            <>
              {/* <div className="dropdown-greeting">Hello, {firstName}</div> */}
              <Link to="/" className="dropdown-item" onClick={(e) => toggleMenu(e, true)}>Home</Link>
              <Link to="/about-us" className="dropdown-item" onClick={(e) => toggleMenu(e, true)}>About Us</Link>
              <Link to="/blog" className="dropdown-item" onClick={(e) => toggleMenu(e, true)}>Blog</Link>
              <Link to="/events" className="dropdown-item" onClick={(e) => toggleMenu(e, true)}>Events</Link>
              {/* <Link to="/profile" className="dropdown-item" onClick={(e) => toggleMenu(e, true)}>Profile</Link>
              <button className="dropdown-item sign-out-button" onClick={handleSignOut}>
                Sign Out
              </button> */}
            </>
          </div>
        )}
      </div>
      {isModalOpen && (
        <div className="sign-in-modal">
          <div className="modal-content">
            <button className="modal-close" onClick={toggleModal}>×</button>
            <h2>Sign In</h2>
            <form onSubmit={handleSignIn}>
              <input
                style={{ width: '90%' }}
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <input
                style={{ width: '90%' }}
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {error && <p className="error-message">{error}</p>}
              <button type="submit" className="modal-sign-in-button">Sign In</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default HeaderBlock;